import push from '@assets/sounds/push.wav';
import { logError } from '@shared/utils/errorLogging';

export type AudioName = 'push';

export const pushAudio = new Audio(push);

export async function play(audioName: AudioName): Promise<void> {
  if (audioName !== 'push') {
    return;
  }
  const audio = pushAudio;
  return new Promise<void>((resolve) => {
    function onError(error: unknown) {
      logError(error);
      onDone();
    }

    function onDone() {
      audio.removeEventListener('ended', onDone);
      audio.removeEventListener('error', onError);
      resolve();
    }

    audio.addEventListener('ended', onDone);
    audio.addEventListener('error', onError);
    if (audio.currentTime > 0) {
      try {
        audio.currentTime = 0;
      } catch (error) {
        logError(error);
      }
    }
    audio.play().catch(onError);
  });
}
